import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { BzTab, BzTabs, BzButton, BzMasterAgGrid, BzChip } from "../../../components";
import { ORDERS_GRID_REF, bIsProd, collapseRow, createNewWatchlist, displayZeroStateForGrid, isGuestUser, GridDateSortingComparator, handleScripUnsubScriptionOnUnMount, convertColumnsDatatoGridColumns, convertTOVariable, deepClone } from "../../../utils/global_functions";
import { GRID_ROW_SELECTION_TYPE, MANAGE_COLUMNS_VIEW_TYPES, MARKET_SEGMENT_ID, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY, ORDER_TYPES, TL_INDEX } from "../../../utils/global_variables";
import OrdersPopover from '../../Orders/OrdersPopover';
import StatusChip from "../StatusChip";
import { useDebounce, useUnload, useWFHMessages } from "../../../hooks";
import { getWfhTouchlineLastTick } from "../../../redux/actions/wfh";
import { handleModal, handleModalData } from "../../../redux/actions/modals";
import { getAllOrders, getScripOrderInfo, isMultipleOrdersCancelnProcess, setCurrentPage } from "../../../redux/actions/orders";
import OrderSymbolColumn from "../OrderSymbolColumn";
import { sendTouchlineRequest } from "../../../apis/web_socket";
import _ from "lodash";
import moment from "moment";
import { _getOrderDisplayStatus } from "../../../controllers";
import ZeroStates from "../../ZeroStates";
import { LoginLoader } from "../../Login";
import config from '../../../config.json';
import GridHeaderSearch from "../../GridHeaderSearch";
import useAnalyticsEventTracker from "../../../hooks/useAnalyticsEventTracker";

const { TenantId } = config;

// Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
let bIsApiFiring = false;
// Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
//Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
const SingleScrip = ({ ordersSingleScripKey, ordersTabKey, handleDelete, activeFilters,
    activeContent, tempOrders, setIsShowOrderFilterModelsModal, onSquareOffClick,
    isButtonDisabled, onRowSelected, onCancelOrder, onTabChange, isRowSelectable, ...props }) => {
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    const dispatch = useDispatch();
    // const CartName = ({ objRowData, ...props }) => {
    //     if (objRowData?.ordercartName?.length > 0) {
    //         return <div>{objRowData?.ordercartName}</div>;
    //     } else {
    //         return <div>-</div>;
    //     }

    // };
    const allOrders = useSelector(state => state?.orders?.allOrders);
    const arrCompletedOrders = useSelector(state => state?.orders?.arrCompletedOrders);
    const arrOpenOrders = useSelector(state => state?.orders?.arrOpenOrders);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);

    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    const nAllSingleScripOrdersLength = useSelector(state => state?.orders?.nAllSingleScripOrdersLength);
    const nOpenSingleScripOrdersLength = useSelector(state => state?.orders?.nOpenSingleScripOrdersLength);
    const nCompletedSingleScripOrdersLength = useSelector(state => state?.orders?.nCompletedSingleScripOrdersLength);
    const nCurrentPage = useSelector(state => state.orders.nCurrentPage);

    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    const arrSingleOrderColumnDefs = useSelector(state => state?.orders?.arrSingleOrderColumnDefs);
    // Azeem K : 22-02-2024 : BT-102298  BSEEQ OrderBook  – Start 
    const bIsOrderApiPending = useSelector(state => state?.orders?.bIsOrderApiPending);
    // Azeem K : 22-02-2024 : BT-102298  BSEEQ OrderBook  – End 
    const [arrOrdersGridRowData, setArrOrdersGridRowData] = useState(allOrders);
    // Azeem K : 01-04-2024 : BT-102298  OrderBook Optamization – Start 
    const [objActiveOrdersIndexes, setArrIndexes] = useState({});
    const searchedText = useRef('');
    const [filteredData, setFilteredData] = useState([]);
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);
    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
    const singleOrdersTenantColumnProfiles = useMemo(() => {
        const futuresColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_SINGLE_SCRIP_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (futuresColumDetails) {
            const updatedColumnDetails = deepClone(futuresColumDetails?.columnDetails)?.map((eachProfile) => {
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                } else {
                    settings = { ...eachProfile?.sSettings };
                }
                eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.ORDER_SINGLE_SCRIP_VIEW_TYPE]?.map((eachProfile) => {
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                } else {
                    settings = { ...eachProfile?.sSettings };
                }
                eachProfile.sSettings = { ...settings, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);
   
    useEffect(() => {
        const objIndexes = {};

        arrOrdersGridRowData?.forEach((each, index) => {
            if (!objIndexes[each.mktIdToken]) {
                objIndexes[each.mktIdToken] = [];
            } else { }
            objIndexes[each.mktIdToken].push(index);
        });
        setArrIndexes(objIndexes);
    }, [arrOrdersGridRowData]);
    // Azeem K : 01-04-2024 : BT-102298  OrderBook Optamization – End 

    const updateSingleScripData = (arrTouchLineData) => {
        // Azeem K : 01-04-2024 : BT-102298  OrderBook Optamization – Start 
        let arrOrdersToUpdate = [];
        const arrIndexesToBeUpdate = objActiveOrdersIndexes[arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN]];
        if (arrIndexesToBeUpdate?.length > 0) {
            arrIndexesToBeUpdate?.forEach((eachIndex) => {
                let objOrder = arrOrdersGridRowData[eachIndex];
                objOrder.ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                objOrder.ltpChange = arrTouchLineData[TL_INDEX.NET_CHANGE_INDICATOR];
                //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
                objOrder.closePrice = arrTouchLineData[TL_INDEX.CLOSE_PRICE];
                objOrder.buyPrice = arrTouchLineData[TL_INDEX.BUY_PRICE];
                objOrder.sellPrice = arrTouchLineData[TL_INDEX.SELL_PRICE];
                //  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End 
                if (objOrder?.mktIdToken === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN]) {
                    arrOrdersToUpdate?.push(objOrder);
                }
            });
        }

        if (arrOrdersToUpdate?.length > 0) {
            if (arrOrdersToUpdate?.length > 0) {
                ORDERS_GRID_REF?.current?.api?.applyTransaction({
                    update: arrOrdersToUpdate
                });
            }
        }
    };

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleVisibleRows = useCallback(() => {
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]
            const arrVisibleRows = ORDERS_GRID_REF?.current?.api?.getRenderedNodes().map(item => {
                let id = item?.data?.mktIdToken;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({
                        exchangeId: item?.data?.mktId
                        , token: item?.data?.scripToken
                        , isSubscribe: true
                    });

                }
                return { exchangeId: item?.data?.mktId, token: item?.data?.scripToken, isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            useDebounce(() => {
                const lastTickData = dispatch(getWfhTouchlineLastTick());
                arrVisibleRows?.forEach((eachScrip) => {
                    let selectedScrip = lastTickData[`${eachScrip?.exchangeId + '_' + eachScrip?.token}`];
                    if (selectedScrip?.length > 0) {
                        updateSingleScripData(selectedScrip);
                    }
                });

            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, [dispatch, updateSingleScripData]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    useEffect(() => {
        //here we send request for only visible scrips
        setTimeout(() => {
            handleVisibleRows();
        }, 1000);
    }, [objActiveOrdersIndexes]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End


    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const handleScrollEnd = async (e) => {
        if (e.direction === 'vertical') {
            handleVisibleRows();

        }
    };
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    const handleVisibleScripsUnSUbscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'singlescrip');
    }, [objScripsRequest]);

    useUnload(() => {
        handleVisibleScripsUnSUbscription();
    });
    // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – Start
    let strSearch = null;

    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        searchedText.current = strSearch;
        ORDERS_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(ORDERS_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = node?.data?.title + node?.data?.exchange + node?.data?.expiryDate + node?.data?.expiryDate + node?.data?.strikePrice + node?.data?.instrument + node?.data?.optionType + node?.data?.series;
                return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
            }
        },
        [strSearch]
    );

    const filterOptions = [
        'equals',
        'notEqual',
        'lessThan',
        'lessThanOrEqual',
        'greaterThan',
        'greaterThanOrEqual',
        'inRange',
        'blank',
        'notBlank'
    ];

    const getFilterDataForGrid = ({ filterOption, value, filterText }) => {
        if (filterText == null) {
            return false;
        } else {
            switch (filterOption) {
                case 'equals': {
                    return parseFloat(filterText) === parseFloat(value);
                }
                case 'notEqual': {
                    return parseFloat(filterText) !== parseFloat(value);
                }
                case 'lessThan': {
                    return parseFloat(value) < parseFloat(filterText);
                }
                case 'lessThanOrEqual': {
                    return parseFloat(value) <= parseFloat(filterText);
                }
                case 'greaterThan': {
                    return parseFloat(value) > parseFloat(filterText);
                }
                case 'greaterThanOrEqual': {
                    return parseFloat(value) >= parseFloat(filterText);
                }
                case 'inRange': {
                    const agFilterModel = ORDERS_GRID_REF?.current?.api?.getFilterModel();
                    if (Object?.keys(agFilterModel)?.length > 0) {
                        const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                        const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                        return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                    } else {
                        return false;
                    }
                }
                case 'blank': {
                    return false;
                }
                case 'notBlank': {
                    return true;
                }
                default:
                    return false;
            }
        }
    };


    // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End



    const RowData = ({ value, objRowData, ...props }) => { return value ? value : '-'; };



    const getEvent = useAnalyticsEventTracker('ORDERBOOK');


    useEffect(() => {
        switch (ordersTabKey) {
            case ORDERS_TABKEY.ALL_ORDERS:
                getEvent('SINGLE SCRIP ORDERS_ALL_ORDERS');
                ORDERS_GRID_REF?.current?.api?.collapseAll();
                setArrOrdersGridRowData(allOrders);

                break;
            case ORDERS_TABKEY.OPEN_ORDERS:
                getEvent('SINGLE SCRIP ORDERS_OPEN_ORDERS');
                ORDERS_GRID_REF?.current?.api?.collapseAll();
                setArrOrdersGridRowData(arrOpenOrders);


                break;
            case ORDERS_TABKEY.COMPLETED_ORDERS:
                getEvent('SINGLE SCRIP ORDERS_COMPLETED_ORDERS');
                ORDERS_GRID_REF?.current?.api?.collapseAll();
                setArrOrdersGridRowData(arrCompletedOrders);

                break;
            default:
                break;
        }

    }, [allOrders, ordersTabKey, arrOpenOrders, arrCompletedOrders]);
    const filterChangeHandler = () => {
        const isFilterApplied = Object.keys(ORDERS_GRID_REF?.current?.api?.getFilterModel())?.length > 0 || searchedText?.current?.length > 0;
        if (isFilterApplied) {
            const filteredData = [];
            ORDERS_GRID_REF?.current?.api?.forEachNodeAfterFilter(node => {
                filteredData.push(node.data);
            });
            setFilteredData(filteredData);
        } else {
            setFilteredData([]);
        }
    };

    //Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start
    const handleApiCall = (bIsScrollToTop = false) => {
        if (!isGuestUser()) {
            switch (ordersTabKey) {
                case ORDERS_TABKEY.ALL_ORDERS:
                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                    dispatch(setCurrentPage(1));

                    break;
                case ORDERS_TABKEY.OPEN_ORDERS:
                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                    dispatch(setCurrentPage(1));


                    break;
                case ORDERS_TABKEY.COMPLETED_ORDERS:

                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }));
                    dispatch(setCurrentPage(1));


                    break;

                default:
                    break;
            }
            if (bIsScrollToTop) {
                ORDERS_GRID_REF.current?.api?.ensureIndexVisible(0, 'top');
            }
        }
    };
    //Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start

    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    useEffect(() => {
        handleApiCall(true);
        onChangeGridHeaderSearch({ target: { value: null } });
    }, [ordersTabKey, dispatch]);

    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


    const getRowId = useCallback((params) => {
        if (params?.data) {
            return params?.data?.orderNo;
        } else {
        }
    }, []);

    const onGridReady = useCallback((params) => {
        params?.api?.updateGridOptions('rowDrag', false);
    }, []);

    // Azeem K : 01-04-2024 : BT-102298  OrderBook Optamization – End 

    useWFHMessages('touchline', (e) => {
        updateSingleScripData([...e.detail]);
    });


    // Azeem K : 21-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    const sortingComparator = useCallback((number1, number2) => {
        number1 = parseFloat(number1);
        number2 = parseFloat(number2);
        if (number1 === null) {
            return 0.00;
        }
        if (number2 === null) {
            return 0.00;
        }
        return number1 - number2;
    }, []);
    // Azeem K : 21-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


    const [customizeColoumns, setArrManageGridCustomizeColoumns] = useState([

    ]);



    const arrOrderSingleScripColumnDefs = useMemo(() => {
        const arrOrderColumnDefs = singleOrdersTenantColumnProfiles?.map((item) => {
            switch (item.field) {

                case 'time':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        ...item, filter: 'agDateColumnFilter', filterParams: {
                            comparator: (dateFromFilter, cellValue) => {
                                if (cellValue === null) { return -1; }
                                const dateParts = moment(cellValue).format('DD/MM/YYYY')?.split('/');
                                const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                                if (dateFromFilter?.getTime() === cellDate?.getDate()) {
                                    return 0;
                                }
                                if (cellDate < dateFromFilter) {
                                    return -1;
                                } else
                                    if (cellDate > dateFromFilter) {
                                        return 1;
                                    }
                                return 0;
                            }
                        },
                        // pinned: 'left',
                        suppressMovable: true,
                        // lockPosition: "left",
                        suppressNavigable: true,
                        comparator: GridDateSortingComparator,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End

                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;

                case 'title':
                    item = {
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        ...item,
                        // maxWidth: 300,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        headerComponent: GridHeaderSearch, cellRendererParams: ((props) => ({
                            placement: 'right',
                            objRowData: props.data
                            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        })),
                        pinned: 'left',
                        suppressMovable: true,
                        lockPosition: "left",
                        suppressNavigable: true,
                        headerComponentParams: { onChangeGridHeaderSearch, gridRef: ORDERS_GRID_REF }
                        , cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <OrderSymbolColumn objRowData={objRowData} props={props} value={value} />
                        </OrdersPopover>,
                        //  width: 550,
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                case 'status':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        ...item,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        filter: 'agMultiColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <StatusChip data={objRowData} bisEnlargementClass={true} />
                        </OrdersPopover>, valueGetter: (params) => _getOrderDisplayStatus(params?.data?.status),
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                case 'type':
                    item = {
                        ...item,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        filter: 'agSetColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellClassRules: {
                            'color-positive': params => params?.data?.type?.toUpperCase() === 'BUY',
                            'color-negative': params => params?.data?.type?.toUpperCase() === 'SELL'
                            //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Startase() === 'SELL'
                        }, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                case 'productTypeDesc':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        ...item,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        filter: 'agSetColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                case 'orderType':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        ...item,
                        filter: 'agSetColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                case 'qty':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        ...item,
                        filter: 'agTextColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                case 'price':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        ...item,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        filter: 'agTextColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>, filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – Start
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        comparator: sortingComparator,

                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;

                case 'ltp':
                    item = {
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        ...item,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        filter: 'agTextColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>, filterParams: {
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions,
                            // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – End
                        },
                        comparator: sortingComparator,
                        cellClassRules: {
                            'background-positive color-active-text': params => params?.data?.ltpChange === 'U',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
                            'background-negative color-active-text': params => params?.data?.ltpChange === 'D',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
                            '': params => params?.data?.ltpChange === 'S',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes 
                        },

                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                //as per new excel  columns commented 11-10-2023 -Azeem Khan
                //     case 'ordercartName':
                //         item = {
                //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                //             ...item, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                //                 <CartName value={value} objRowData={objRowData} props={props} />
                //             </OrdersPopover>,
                //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                //             valueGetter: ((params) => params.data?.ordercartName)
                //         };
                //         return item;
                case 'orderNo':
                    item = {
                        // Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        ...item, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>, valueGetter: ((params) => params.data?.orderNo),
                        // Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                // Azeem K : 15-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start 
                case 'validity':
                    item = {
                        // Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
                        ...item,
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                        filter: 'agTextColumnFilter',
                        // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
                    };
                    return item;
                // Azeem K : 15-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End 
                // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
                case 'averagePrice':
                    item = {
                        ...item, filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        }, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>,
                        comparator: sortingComparator,
                    };
                    return item;
                case 'trigger_price':
                    item = {
                        ...item, filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        }, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>,
                        comparator: sortingComparator,
                    };
                    return item;
                case 'initiated_by':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                    };
                    return item;
                case 'modified_by':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                    };
                    return item;
                case 'exchangeDateTime':
                    item = {
                        ...item, filter: 'agDateColumnFilter', filterParams: {
                            comparator: (dateFromFilter, cellValue) => {
                                if (cellValue === null) { return -1; }
                                const dateParts = moment(cellValue).format('DD/MM/YYYY')?.split('/');
                                const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                                if (dateFromFilter?.getTime() === cellDate?.getDate()) {
                                    return 0;
                                }
                                if (cellDate < dateFromFilter) {
                                    return -1;
                                } else
                                    if (cellDate > dateFromFilter) {
                                        return 1;
                                    }
                                return 0;
                            }
                        },
                        comparator: GridDateSortingComparator,
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                    };
                    return item;
                case 'validity_date':
                    item = {
                        ...item, filter: 'agDateColumnFilter', filterParams: {
                            comparator: (dateFromFilter, cellValue) => {
                                if (cellValue === null) { return -1; }
                                const dateParts = moment(cellValue).format('DD/MM/YYYY')?.split('/');
                                const cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));
                                if (dateFromFilter?.getTime() === cellDate?.getDate()) {
                                    return 0;
                                }
                                if (cellDate < dateFromFilter) {
                                    return -1;
                                } else
                                    if (cellDate > dateFromFilter) {
                                        return 1;
                                    }
                                return 0;
                            }
                        },
                        comparator: GridDateSortingComparator,
                        cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                    };
                    return item;
                case 'exchangeOrderNumber':
                    item = {
                        ...item, filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        }, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>,
                        comparator: sortingComparator,

                    };
                    return item;
                //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
                case 'disclosed_quantity':
                    item = {
                        ...item, filter: 'agTextColumnFilter', filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        }, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>,
                        comparator: sortingComparator,
                    };
                    return item;
                //Azeem K : 05-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - ERROR REASON COLUMN ADDED - Start
                case 'error_reason':
                    item = {
                        ...item, filter: 'agTextColumnFilter', filterParams: {
                            // textMatcher: getFilterDataForGrid,
                            // filterOptions: filterOptions
                        }, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>,
                        valueGetter: (params) => params?.data?.error_reason?.length > 0 ? params?.data?.error_reason : '-',
                        comparator: sortingComparator,
                    };
                    return item;
                //Azeem K : 05-04-2024 : BT-102298 - Breeze - Single Scrip Order entry - ERROR REASON COLUMN ADDED - end
                //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
                default:
                    item = {
                        ...item, cellRenderer: ({ data: objRowData, value, ...props }) => <OrdersPopover activeContent={activeContent} objRowData={objRowData} placement='left' {...props}>
                            <RowData value={value} objRowData={objRowData} props={props} />
                        </OrdersPopover>
                    };
                    return item;
                // Azeem K : 29-11-2023 :BT-101818 : Order Book - Single Scrip Order  ---End


            }
        });

        const objChecboxColumn = [{
            colId: "check",
            lockPosition: "left",
            hide: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            pinned: 'left',
            width: '40'
        }, {
            headerName: "", field: "expandCell",
            cellRenderer: 'agGroupCellRenderer',
            pinned: 'left',
            width: '50',
            maxWidth: 50,
            detailCellRendererParams: { placement: 'right' },
            pinned: 'left',
            suppressMovable: true,
            lockPosition: "left",
            suppressNavigable: true,
            menuTabs: [],
            cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" }
        }];
        return [...objChecboxColumn, ...arrOrderColumnDefs];
        //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - Start
    }, [singleOrdersTenantColumnProfiles, ordersTabKey]); //Vaibhav Singh: 20-02-24:Updated dependency: Start 
    //Maaz A : 08-11-2023 : BT-120115 - Breeze - Order Book - Good Till Date - End
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start
    const [nGridHeight, setNGridHeight] = useState(0);
    const rowNode = useMemo(() => {

        return ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
    }, []);
    const nRowHeight = rowNode?.rowHeight;

    useEffect(() => {
        if (arrOrdersGridRowData?.length > 0) {
            setNGridHeight(+arrOrdersGridRowData?.length * nRowHeight);
        }
    }, [arrOrdersGridRowData, nRowHeight, ORDERS_GRID_REF?.current]);

    const handleApiCallOnScroll = (offSet) => {
        let nMaxLimit = 0;
        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
            nMaxLimit = nAllSingleScripOrdersLength;
        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
            nMaxLimit = nOpenSingleScripOrdersLength;
        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
            nMaxLimit = nCompletedSingleScripOrdersLength;
        }

        // Azeem K :20-03-2024:BT-102298 BSEFO Bug fixing:auto select checkboxes when user select all orders -Start

        let bIsAllRowSelected = false;
        const nSelectedRowsCount = ORDERS_GRID_REF?.current?.api?.getSelectedNodes()?.length;
        let nSelectableRows = 0;
        ORDERS_GRID_REF?.current?.api?.forEachNode((node) => {
            if (node?.selectable) {
                nSelectableRows++;
            }

        });

        if (nSelectableRows === nSelectedRowsCount && bIsMultipleOrdersCancelinProcess) {

            bIsAllRowSelected = true;
        } else {
            bIsAllRowSelected = false;

        }
        // Azeem K :20-03-2024:BT-102298 BSEFO Bug fixing:auto select checkboxes when user select all orders -End

        if (arrOrdersGridRowData?.length < nMaxLimit && offSet > nCurrentPage) {
            dispatch(setCurrentPage(offSet));


            dispatch(getAllOrders({ offSet: offSet, limit: ORDERS_LIMIT_IN_API, orderStatus: ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ? ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS : ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS ? ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS : ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS })).then((objresp) => {
                bIsApiFiring = false;
                // Azeem K :20-03-2024:BT-102298 BSEFO Bug fixing:auto select checkboxes when user select all orders -Start
                if (bIsMultipleOrdersCancelinProcess && bIsAllRowSelected) {
                    setTimeout(() => {
                        ORDERS_GRID_REF?.current?.api?.forEachNode((node) => {
                            node.setSelected(true);
                        });
                    }, 500);
                }
                // Azeem K :20-03-2024:BT-102298 BSEFO Bug fixing:auto select checkboxes when user select all orders -End

            }
            ).catch((error) => {
                bIsApiFiring = false;
                console.log(error);
            });

        } else {
            bIsApiFiring = false;

        }

    };

    const handleScroll = () => {
        const gridApi = ORDERS_GRID_REF.current.api;
        const scrollPosition = gridApi?.getVerticalPixelRange()?.bottom;
        const rowNode = ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
        const nRowHeight = rowNode?.rowHeight;
        setNGridHeight(+arrOrdersGridRowData?.length * nRowHeight);

        if (nGridHeight - scrollPosition <= nRowHeight * 5 && !bIsApiFiring) { //nRowHeight * 5===> call api when 5 row remaining on scroll
            bIsApiFiring = true;
            handleApiCallOnScroll(nCurrentPage + 1);
        }

    };
    // Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End
    //   Azeem K : 23-02-2024 : BT-102298 added place order button in zero state   – Start 
    const handlePlaceOrder = () => {
        dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.SINGLE_SCRIP } }));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
        dispatch(getScripOrderInfo(objScrpinfo));
    };
    //   Azeem K : 23-02-2024 : BT-102298 added place order button in zero state   – End 
    //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start
    const bIsMultipleOrdersCancelinProcess = useSelector(state => state.orders?.bIsMultipleOrdersCancelinProcess);
    const onRowGroupOpened = () => {
        if (bIsMultipleOrdersCancelinProcess) {
            collapseRow(ORDERS_GRID_REF, true);
        }

    };
    //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments - Start

    // Hari k:22-03-2024: BT-108447: create watchlist from list- start
    const handleCreateWatchlist = () => {
        const arrScrips = arrOrdersGridRowData?.map((eachScrip) => {
            return { nMarketSegmentId: eachScrip?.mktId, nToken: eachScrip?.scripToken };
        });
        createNewWatchlist(objLoginSession, arrScrips, "dynamic", TenantId, 'My Orders', dispatch);
    };
    // Hari k:22-03-2024: BT- 108447:create watchlist from list- end
    //Ameersha N : 15-04-2024 :BT-102298 - Breeze -  Single Scrip Order Book --Start
    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                rowSelection: 'multiple',
                suppressRowClickSelection: true,
                enableRangeSelection: false,
                pagination: false,
                paginationAutoPageSize: false,
                suppressContextMenu: true,

                columnDefs: [
                    {
                        //Azeem K : 14-06-2024 :BT-102298 - Breeze -  Single Scrip Order Book -Regression Bug fixing NSECDS --Start
                        field: 'trade_timestamp', headerName: 'Time', suppressMenu: true, valueFormatter: params => params.value ? moment(params.value).format("hh:mm a, DD MMM 'YY") : ''
                        //Azeem K : 14-06-2024 :BT-102298 - Breeze -  Single Scrip Order Book -Regression Bug fixing NSECDS --End
                    },
                    { field: 'trade_no', headerName: "Trade No", suppressMenu: true, },
                    { field: 'trade_quantity', headerName: "Qty", suppressMenu: true },
                    { field: 'trade_price', headerName: 'Price', minWidth: 150, suppressMenu: true },
                ],
                defaultColDef: {
                    flex: 1,
                    suppressMovable: true,
                    lockPosition: 'left',
                    suppressNavigable: true,
                },
            },
            getDetailRowData: (params) => {

                let temp = params.data.trades;
                //Azeem K : 14-06-2024 :BT-102298 - Breeze -  Single Scrip Order Book -Regression Bug fixing NSECDS --Start
                let newData = params?.data?.trades?.map((eachTrade) => {
                    return {
                        ...eachTrade,
                        trade_quantity: eachTrade?.trade_quantity?.toString()
                    };
                });
                if (params?.data?.trades?.length > 0) {
                    newData?.push({
                        trade_price: 'Average Price : ' + params?.data?.averagePrice,
                        trade_quantity: 'Total Qty ' + _.sumBy(temp, (obj) => Number(obj.trade_quantity)),
                        bIsAddedBottomRow: true
                    });
                }
                //Azeem K : 14-06-2024 :BT-102298 - Breeze -  Single Scrip Order Book -Regression Bug fixing NSECDS --End
                params.successCallback(newData);
            },
        };
    }, []);
    //Ameersha N : 15-04-2024 :BT-102298 - Breeze -  Single Scrip Order Book --End

    useEffect(() => {
        return (() => {
            dispatch(isMultipleOrdersCancelnProcess(false));
        });
    }, []);

    const selectionColumnDef = useMemo(() => {
        return {
            pinned: 'left',
            hide: true,
        };
    }, []);

    const rowSelection = useMemo(() => {
        return {
            mode: isButtonDisabled || bIsMultipleOrdersCancelinProcess ? GRID_ROW_SELECTION_TYPE.MULTI_ROW : GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
            isRowSelectable: (params) => isRowSelectable(params),
            enableClickSelection: true
        };
    }, [isRowSelectable, isButtonDisabled, bIsMultipleOrdersCancelinProcess]);

    useEffect(() => {
        ORDERS_GRID_REF?.current?.api?.forEachNode(node => {
            if (bIsMultipleOrdersCancelinProcess || isButtonDisabled) {
                node.selectable = isRowSelectable(node);
            } else {
                node.selectable = true;
                if (node?.firstChild) {
                    setTimeout(() => {
                        node.setSelected(true);
                    }, 100);
                }
            }

        });
        ORDERS_GRID_REF?.current?.api?.redrawRows();
    }, [bIsMultipleOrdersCancelinProcess, isButtonDisabled, isRowSelectable, dispatch]);

    const onGridPreDestroyed = useCallback((params) => {
        // this function gets called when the grdi before gets destroyed means getting removed from dom
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'singleScrip');
    }, [objScripsRequest]);

    const defaultColProps = {
        minWidth: 200
    };
    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 pt-1 px-3'>
                    <Col md={7}>
                        <BzTabs className='nav nav-tabs'>
                            {/* Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */}
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('all_orders')} isActive={ordersTabKey === ORDERS_TABKEY.ALL_ORDERS} tabKey='all_orders'>{`All Orders(${nAllSingleScripOrdersLength || 0})`}</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('open_orders')} isActive={ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS} tabKey='open_orders'>{`Open Orders(${nOpenSingleScripOrdersLength || 0})`}</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('completed_orders')} isActive={ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS} tabKey='completed_orders'>{`Completed Orders(${nCompletedSingleScripOrdersLength || 0})`}</BzTab>
                            {/* Azeem K : 07-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---End */}
                        </BzTabs>
                    </Col>
                    <Col md={5}>
                        <div className='d-flex justify-content-end align-items-center pt-1'>
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- start*/}
                            {/* {ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ?
                                <div className={`d-flex align-items-center cursor-pointer ${arrOrdersGridRowData?.length < 1 ? 'div-disabled' : ''}`}>
                                    <BzButton className='btn btn-sm btn-outline d-flex align-items-center ms-3' onClick={handleCreateWatchlist}>
                                        <div class="icon-12 icon-add icon-primary me-2"></div>
                                        <span className='font-medium'>Watchlist</span>
                                    </BzButton>
                                </div> : null} */}
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- start*/}

                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start */}
                            <div className='d-flex align-items-center cursor-pointer focus p-1 me-3 gap-2' onClick={handleApiCall.bind(this, true)}>
                                <div className='icon-16 icon-refresh background-textual-link-withicon d-flex flex-shrink-0'></div>
                                <div className='font-medium font-size3 color-textual-link-withicon p-t-2'>Refresh</div>
                            </div>
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --End */}
                            {/* Azeem K : 11-12-2023 :BT-101818 : Order Book - Single Scrip Order  ---Start */}

                            {/* Azeem k :09-11-2023 :code commented as per discussion with akshay square off will be remove code will remove later */}
                            {/* {ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS ?
                                <BzButton className='btn btn-outline btn-sm text-capitalize ms-5' onClick={onSquareOffClick} disabled={isButtonDisabled}>Square off all</BzButton>
                                :
                                <BzButton className='btn btn-outline btn-sm text-capitalize ms-5' onClick={onCancelOrder} disabled={isButtonDisabled}>Cancel Order</BzButton>} */}
                            {/* Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:Start */}
                            {ordersTabKey !== ORDERS_TABKEY.COMPLETED_ORDERS ?
                                <BzButton className='btn btn-outline btn-sm text-capitalize ms-3' onClick={onCancelOrder} disabled={isButtonDisabled}>Cancel All Order</BzButton> : null}
                            {/* Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:End */}
                        </div>
                    </Col>
                </Row>
                <Row className='g-0'>
                    <div className='d-flex align-items-center'>
                        {activeFilters && Object.keys(activeFilters).length > 0 ? <div className='font-regular font-size4 color-text d-flex justify-content-center align-items-center p-3'>Filters:</div> : null}

                        {activeFilters && Object.keys(activeFilters).length > 0 &&
                            Object.keys(activeFilters).map((objFilterKey, i) =>
                                <div className='filters-chips-wrap'>
                                    <BzChip key={i} className='filter-chip me-2 text-capitalize'>{activeFilters[objFilterKey]}<div onClick={() => handleDelete(activeFilters[objFilterKey], i)} className='icon-close icon-dark ms-2'></div></BzChip>
                                </div>
                            )
                        }

                        {tempOrders.filter(Boolean).map((te, i) => {
                            return (
                                <>
                                    <div className='filters-chips-wrap'>
                                        <BzChip key={i} className=' me-2'>{te}<div onClick={() => handleDelete(te, i)} className='icon-10 icon-close icon-dark ms-2'></div></BzChip>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                </Row>
            </Container>
            {/* Azeem K : 13-12-2023 :BT-101818 : Order Book - Single Scrip Order –--Start */}
            <LoginLoader spinner={bIsOrderApiPending} spinnerContent="Fetching Details" />
            {arrOrdersGridRowData?.length > 0 ?
                <div className='mt-2'>
                    <BzMasterAgGrid
                        gridProfileType={MANAGE_COLUMNS_VIEW_TYPES.ORDER_SINGLE_SCRIP_VIEW_TYPE}
                        selectionColumnDef={selectionColumnDef}
                        rowSelection={rowSelection}
                        onBodyScrollEnd={handleScrollEnd}
                        rowBuffer={1}
                        arrColumnData={arrOrderSingleScripColumnDefs} arrRowData={arrOrdersGridRowData} ref={ORDERS_GRID_REF}
                        isMasterDetail={true} isSuppressMenu={false}
                        onGridPreDestroyed={onGridPreDestroyed}
                        suppressRowClickSelection={false}
                        gridDetailCellRendererParams={detailCellRendererParams}
                        rowHeight={36} detailRowAutoHeight={true} className='ag-theme-alpine orders-ag-grid-wrapper'
                        getRowId={getRowId} onRowSelected={onRowSelected}
                        isRowSelectable={isRowSelectable} onGridReady={onGridReady}
                        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – Start
                        isExternalFilterPresent={isExternalFilterPresent} doesExternalFilterPass={doesExternalFilterPass} onBodyScroll={handleScroll}
                        // Azeem K : 09-11-2023 :BT-101818 : Order Book - Single Scrip Order – Issue -  search functionality not working proper – Start
                        rowClass='font-enlarge' //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                        onRowGroupOpened={onRowGroupOpened} //Azeem K : 06-03-2024 : BT-102298 - Breeze - Single Scrip Order entry - All segments 
                        defaultColProps={defaultColProps}
                    />
                </div> : !bIsOrderApiPending && arrOrdersGridRowData?.length <= 0 ?
                    <div className='zero-state-alerts zero-state-alerts-xxl'>
                        <ZeroStates handleOnClick={handlePlaceOrder} heading="No orders available" icon='icon-100 icon-nodata mb-2 mrgauto' btnText="Place an order today" btnClass="btn btn-md btn-outline mt-2" />
                    </div> : null
            }
            {/* Azeem K : 13-12-2023 :BT-101818 : Order Book - Single Scrip Order –--End */}

        </>
    );
};


export default memo(SingleScrip);